
export default {
  methods: {
    // role검증용 글로벌 메소드.
    hasRxRole: function(roles, to) {
      let result = false;
      let rolesArray = new Array();
      if(typeof roles == "string") {
        // 배열이 아닌 경우 배열 객체로 변환
        rolesArray.push(roles);
      } else {
        rolesArray = roles
      }
      if (rolesArray !== null && rolesArray.length > 0) {
        // 사용자 role취득
        const userRoles = this.$store.getters["auth/getRoles"];
        if(userRoles) {
          result = rolesArray.some((role) => {
            return userRoles.some((userRole) => userRole === role);
          });
        } else {
          to = null;
        }
      } else {
        result = true;
      }
      // if(!result && to !== null) {
      if(!result && to) {
          this.$router.push(to).catch(()=>{});
      } else {
        return result;
      }
    },
    // 다국어 코드 존재여부 체크 메소드
    hasRxLocale: function(message) {
      let rst = false;
      
      //  현재 사용가능한 모든 로케일코드로 체크
      // 하나라도 사용 코드가 존재할 경우 true
      const localeList = this.$i18n.availableLocales;
      localeList.forEach(locale => {
        if(this.$i18n._exist(this.$i18n.messages[locale],message)){
          rst = true;
        } 
      });
      return rst;
    },
    // 날짜 차이 일수 계산
    rxDateDiff(date1, date2) {
      let diff = Math.abs(date1.getTime() - date2.getTime());
      diff = Math.ceil(diff / (1000 * 3600 * 24))-1;
      return diff;
    },
    rxDateAdd(date, days) {
      let result = null;
      if("string" == typeof date) {
        result = new Date(date);
      } else {
        result = date;
      }
      result.setDate(result.getDate() + days);
      return result; 
    },
    rxMinutesDiff(date1, date2) {
      let t2= this.$moment(date2 , 'YYYY-MM-DD HH:mm:ss');
      let t1 = this.$moment(date1 , 'YYYY-MM-DD HH:mm:ss');
      return Number(this.$moment.duration(t2.diff(t1)).asMinutes()).toFixed(1) + " " + this.$t("common.lbl.min");
    },
    getUUID() {
      const uuidv4 = require("uuid/v4");
      const newUUID = uuidv4();
      return newUUID;
    },
    $rxt(messageCode, defaultLabel) {
      if (this.$te(messageCode)) {
        return this.$t(messageCode);
      } else if (defaultLabel) {
        return defaultLabel;
      } else {
        this.$t(messageCode);
      }
    },
  },
};
